/**
 * A very simplistic lightbox.
 */

let mainElement: HTMLDivElement
let contentElement: HTMLDivElement

addEventListener('DOMContentLoaded', () => {
	// Find all elements with a `data-lb` attributes.
	// Anchors shouls always open the lightbox when clicked (with the lmb).
	const anchors = Array.from(document.querySelectorAll('a[data-lb]')) as HTMLAnchorElement[]
	for (const anchor of anchors) {
		anchor.addEventListener('click', (event) => {
			if (anchor.href && event.button === 0) {
				event.preventDefault()
				open(anchor.href, ContentMode.Iframe)
			}
		})
	}

	// Find other elements?
	// ...
})

function init() {
	mainElement = document.createElement('div')
	mainElement.id = 'lightbox'
	document.body.appendChild(mainElement)

	contentElement = document.createElement('div')
	contentElement.classList.add('content')
	mainElement.appendChild(contentElement)

	const closeButton = document.createElement('button')
	closeButton.addEventListener('click', () => close())
	closeButton.classList.add('close')
	mainElement.appendChild(closeButton)
}

export enum ContentMode {
	// Auto,
	Iframe = 'iframe',
	Image = 'image',
	Video = 'video'
}

export function open(source: string, mode: ContentMode) {
	if (!mainElement) {
		init()
	}

	contentElement.innerHTML = ''

	switch (mode) {
		case ContentMode.Iframe: {
			const iframe = document.createElement('iframe')
			iframe.src = source
			contentElement.appendChild(iframe)
		} break
		case ContentMode.Image: {
			const img = new Image()
			img.src = source
			contentElement.appendChild(img)
		} break
		case ContentMode.Video: {
			const video = document.createElement('video')
			video.src = source
			contentElement.appendChild(video)
		} break
	}

	mainElement.classList.add('show')
}

export function close() {
	if (!mainElement) {
		return
	}

	mainElement.classList.remove('show')

	setTimeout(() => {
		if (!mainElement.classList.contains('show')) {
			contentElement.innerHTML = ''
		}
	}, 1e3)
}